export const btnGold = "bg-[#C9A96E] text-black font-semibold px-6 py-3 text-sm hover:bg-[#E5C384] transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
export const btnGhost = "border border-white/15 px-6 py-3 text-sm hover:bg-white/5 transition-colors disabled:opacity-40";
export const inputCls = "w-full bg-[#14161D] border border-white/10 px-3 py-2.5 text-sm outline-none focus:border-[#C9A96E] transition-colors";

export function Field({ label, testid, ...props }) {
  return (
    <label className="block">
      <span className="label-xs">{label}</span>
      <input data-testid={testid} className={`${inputCls} mt-1.5`} {...props} />
    </label>
  );
}

export function Page({ title, kicker, children }) {
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 py-12">
      {kicker && <div className="label-xs mb-3">{kicker}</div>}
      {title && <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-10">{title}</h1>}
      {children}
    </section>
  );
}

export const STATUS_FR = {
  pending_payment: "En attente de paiement", paid: "Payée", forwarded: "Transmise au fournisseur", shipped: "Expédiée", delivered: "Livrée",
  supplier_error: "Incident fournisseur", expired: "Paiement expiré", payment_failed: "Paiement échoué", refunded: "Remboursée",
  partially_refunded: "Partiellement remboursée", requested: "Demandée", under_review: "En cours d'examen", rejected: "Refusée",
  validation_required: "En préparation", ready_to_order: "En préparation", supplier_submitted: "Commandée au fournisseur", supplier_confirmed: "Confirmée par le fournisseur",
  processing: "En préparation", supplier_problem: "Retard fournisseur", cancelled: "Annulée",
};
